import { computed, Directive, inject } from '@angular/core';

import { MessagesConstants } from '@shared/constants/messages.constants';
import { EventType, WorkflowStep } from '@shared/services/gql.service';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { EventQuery } from '@shared/store/event/event.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

@Directive({
  standalone: true,
})
export class CurveWorkflowDirective {
  eventQuery = inject(EventQuery);
  launchDarklyService = inject(LaunchDarklyService);
  workflowQuery = inject(WorkflowQuery);

  isLocked = computed(() => {
    if (this.isClosingPanelEnabled() && this.isQuarterCloseEnabled()) {
      return this.iCloseMonthsProcessing() || this.isPatientsFinalized();
    }

    return false;
  });
  tooltip = computed(() => {
    if (this.isLocked()) {
      return MessagesConstants.SITE_PATIENT_CUSTOM_CURVES_LOCKED_TEXT;
    }

    return '';
  });

  iCloseMonthsProcessing = this.eventQuery.selectProcessingEvent(EventType.CLOSE_TRIAL_MONTH);
  isClosingPanelEnabled = this.launchDarklyService.$select(
    (flags) => flags.closing_checklist_toolbar
  );
  isPatientsFinalized = this.workflowQuery.getLockStatusByWorkflowStepType(
    WorkflowStep.WF_STEP_MONTH_CLOSE_LOCK_CURVES
  );
  isQuarterCloseEnabled = this.workflowQuery.isWorkflowAvailable;
}
